import { NormalBrowseFileInputFiled, NormalTextInputField } from "@/components";
import React, { useMemo } from "react";

const FAQsCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="faqs-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("faqs-banner-image", id)
                  : handleImageChange("faqs-banner-image", "")
              }
              selectedFileId={formData?.["faqs-banner-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="faqs-banner-heading"
            fieldName="faqs-banner-heading"
            placeholderText="Banner Heading"
            inputValue={formData?.["faqs-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="faqs-banner-description"
            fieldName="faqs-banner-description"
            placeholderText="Banner Description"
            inputValue={formData?.["faqs-banner-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default FAQsCMSForm;
